import classnames from 'classnames2';
import React from 'react';

import { Button, CloseButton } from '../Button';

import styles from './Toast.scss';

export const ToastTypes = {
  FAILURE: 'FAILURE' as const,
  SUCCESS: 'SUCCESS' as const
};

export type IToastTypes = keyof typeof ToastTypes;

export interface IToastProps {
  className?: string;
  bodyText?: string;
  headerText?: string;
  actionText?: string;
  type?: IToastTypes;
  dismissible?: boolean;
  hidden?: boolean;
  dataTest?: string;
  handleAction?(): void;
  handleClose?(): void;
}

export const Toast: React.FC<IToastProps> = props => {
  const {
    actionText,
    className,
    type,
    dismissible = true,
    hidden,
    handleClose,
    headerText,
    bodyText,
    handleAction
  } = props;

  const classes = {
    [styles.success]: type === ToastTypes.SUCCESS,
    [styles.failure]: type === ToastTypes.FAILURE
  };

  const buttonColor = type === ToastTypes.SUCCESS ? 'positive' : 'negative';

  if (hidden) {
    return null;
  }
  const role = type === ToastTypes.SUCCESS ? 'status' : 'alert';
  const ariaLive = type === ToastTypes.SUCCESS ? 'polite' : 'assertive';
  return (
    <div
      data-test={props.dataTest}
      className={classnames(styles.toast, classes, className)}
      role={role}
      aria-live={ariaLive}
    >
      {dismissible && <CloseButton className={styles.close} onClick={handleClose} />}
      <h4 className={styles.header}>{headerText}</h4>
      <div className={styles.body}>{bodyText}</div>
      {actionText && (
        <Button className={styles.action} color={buttonColor} onClick={handleAction}>
          {actionText}
        </Button>
      )}
    </div>
  );
};
